// extracted by mini-css-extract-plugin
export default {"content":"style_content__6cbDZ","ant-table-tbody":"style_ant-table-tbody__Q-0zt","checkbox":"style_checkbox__vNhVA","select":"style_select__JHynx"};